import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import CropFreeIcon from "@material-ui/icons/CropFree";
import InputIcon from "@material-ui/icons/Input";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { history } from "../components/helpers/History";
import Logo from "../components/logo/Logo";
import { useDispatch } from "react-redux";
import { UserActions } from "../redux/actions/UserActions";
import { USER_ROLE } from "../components/security/UserRole";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    position: "fixed",
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    background: theme.navbar.background.color,
    color: theme.navbar.background.contrastText,
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    background: "#000",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    background: "#000",
  },
  grow: {
    flexGrow: 1,
  },
}));

const AppNavBar = ({ handleDrawerToggle, ...rest }) => {
  const classes = useStyles();
  const user = useSelector((state) => state.authentication.user);
  const dispatch = useDispatch();
  const handleLogOut = () => {
    dispatch(UserActions.logout());
    history.push("/login");
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="absolute" className={classes.appBar}>
        <Toolbar>
          <Hidden mdUp>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
          </Hidden>
          <Hidden xsDown>
            <Logo />
          </Hidden>

          <div className={classes.grow} />
          <div>
            {user.userRole !== USER_ROLE.PATIENT ? (
              <IconButton
                color="inherit"
                className={classes.menuButton}
                onClick={() => {
                  history.push("/scanner");
                }}
              >
                <CropFreeIcon />
              </IconButton>
            ) : null}
            {/* <IconButton aria-label="show 11 new notifications"
                 color="inherit"
                 >
                  <Badge badgeContent={11} color="secondary">
                    <NotificationsIcon />
                  </Badge>
                </IconButton> */}
            <Hidden xsDown>
              <IconButton
                color="inherit"
                onClick={handleLogOut}
                className={classes.menuButton}
              >
                <InputIcon />
              </IconButton>
            </Hidden>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

AppNavBar.propTypes = {
  handleDrawerToggle: PropTypes.func,
};

export default AppNavBar;
